import React, {useState} from "react";
import {Alert, Button, Card} from "react-bootstrap";
import {httpsCallable} from "@firebase/functions";
import {functions} from "../../../firebase/FirebaseProvider";
import PageTracking from "../../auth/PageTracking";
import SuperAdminNav from "./SuperAdminNav";
import LoginGraphCard from "./LoginGraphCard";
import SessionGraphCard from "./SessionGraphCard";

function SuperAdminStats() {
    const [refreshingStats, setRefreshingStats] = useState<boolean>(false);
    const [refreshMessage, setRefreshMessage] = useState<string>("");
    const [refreshError, setRefreshError] = useState<string>("");

    const forceRefreshStats = async () => {
        setRefreshingStats(true);
        setRefreshMessage("");
        setRefreshError("");

        try {
            const refreshStats = httpsCallable(functions, "forceRefreshStats");
            await refreshStats();
            setRefreshMessage("Stats refreshed");
        } catch (error: any) {
            console.error("Error refreshing stats:", error);
            setRefreshError(error.message || "Failed to refresh stats");
        } finally {
            setRefreshingStats(false);
        }
    };

    return (
        <>
            <PageTracking />
            <SuperAdminNav />

            <Card className={"mb-3"}>
                <Card.Header>
                    <div className="d-flex justify-content-between align-items-center">
                        <div><b>Stats</b></div>
                        <Button variant="primary" size="sm" onClick={forceRefreshStats} disabled={refreshingStats}>
                            {refreshingStats ? "Refreshing..." : "Force refresh stats"}
                        </Button>
                    </div>
                </Card.Header>
                {(refreshMessage || refreshError) && (
                    <Card.Body>
                        {refreshMessage && <Alert variant="success" className="mb-0">{refreshMessage}</Alert>}
                        {refreshError && <Alert variant="danger" className="mb-0">{refreshError}</Alert>}
                    </Card.Body>
                )}
            </Card>
            
            <LoginGraphCard />
            
            <SessionGraphCard />
        </>
    );
}

export default SuperAdminStats;
